document.addEventListener("rebuy:smartcart.ready", () => {
  Rebuy.SmartCart.destroy();
});

if (!customElements.get('mini-cart')) {
  class MiniCart extends HTMLElement {
    constructor() {
      super();
      this.cartModalOpen = false;
    }

    connectedCallback() {
      this.cartUrl = this.dataset.cartUrl;
      this.sectionId = this.dataset.sectionId;
      this.cart = JSON.parse(this.dataset.cartJson || null);

      this.init();
    }

    init() {
      this.addDelegatedClickListeners();
      this.getRecommendedProducts();
      
      this.classList.remove('loading');
      this.scrollTop = this.querySelector('form')?.scrollTop;
    }

    addDelegatedClickListeners() {
      ['mousedown', 'touchstart'].forEach(eventType => document.addEventListener(eventType, (e) => {
        if (!this.isConnected) return;
        if (window.location.pathname === this.cartUrl) return;

        if (e.target.closest('[data-close-cart]') && this.cartModalOpen) {
            this.close();
            return;
        }
        if (e.target.matches('body.overlay') && this.cartModalOpen) {
            this.close();
            return;
        }
      }));
      
      document.addEventListener('click', (e) => {
        if (e.target.closest(`[href="${this.cartUrl}"]`)) {
          e.preventDefault();
          this.open();
          return;
        }
      });
      
      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-cart-action]');
        if (!clickedElement) return;
        
        const {
          cartAction: action,
          lineItemId,
          quantity,
          tabTarget
        } = clickedElement.dataset;
        
        switch (action) {
          case 'updateQty':
            this.classList.add('loading');
            this.updateQty(lineItemId, Number(quantity))
              .then((res) => {
                if (!res) return;
                window.dispatchEvent(new CustomEvent('cart:cartChanged', { 
                  detail: { 
                    bagID: res.token,
                    bagItems: res.items.map(item => {
                      return {
                        "skuCode": `${item.sku}`,
                        "quantity": Number(item.quantity),
                        "price": (item.price / 100)
                      }
                    }),
                    bagQuantity: res.item_count,
                    bagItemCount: res.items.length,
                    bagSubTotal: (res.items_subtotal_price / 100)
                  }
                }));

                this.updateCartHtml(res).then(() => {
                  this.querySelector('form')?.scrollTo({ top: this.scrollTop || 0, left: 0, behavior: 'auto' });
                });
              }).finally(() => this.classList.remove('loading'));
          break;
          case 'apply-promo':
            this.classList.remove('empty-error', 'discount-error');
            const promoCode =  this.querySelector('input#promoInput').value
            if(promoCode == '') {
              this.classList.add('empty-error');
            } else {
              this.classList.add('loading');
              this.getCartId(promoCode);
            };
          break
          case 'clear-promo':
            this.classList.remove('empty-error', 'discount-error');
            this.classList.add('loading');
            this.getCartId('');
          break
          case 'cart-tab':
            this.switchTab(tabTarget)            
          break
          default: break;
        }
      });

      window.addEventListener('submit', (e) => {
        const productForm = e.target.closest(`[action="${Shopify.routes.root}cart/add"]`);
        if(!productForm) return;
        e.preventDefault();

        this.classList.add('loading');
        this.addToCart(productForm)
          .then((validated) => {
            if (validated === false) { return false; }
            this.classList.remove('loading');
            this.open();
          })
      });
      
      window.addEventListener('cart:removeItem', e => {
        if (!e.detail.itemKey) return;
        this.classList.add('loading');
        this.updateQty(e.detail.itemKey, 0)
          .then((res) => {
            if (!res) return;
            window.dispatchEvent(new CustomEvent('cart:cartChanged', { 
              detail: { 
                bagID: res.token,
                bagItems: res.items.map(item => {
                  return {
                    "skuCode": `${item.sku}`,
                    "quantity": Number(item.quantity),
                    "price": (item.price / 100)
                  }
                }),
                bagQuantity: res.item_count,
                bagItemCount: res.items.length,
                bagSubTotal: (res.items_subtotal_price / 100)
              }
            }));

            this.updateCartHtml(res).then(() => {
              this.querySelector('form')?.scrollTo({ top: this.scrollTop || 0, left: 0, behavior: 'auto' });
            });
          }).finally(() => this.classList.remove('loading'));
      })
    }

    // Discount code input
    async discountCode(cartToken, promoCode) {
      const storefrontAccessToken = 'd203fff987720acd5bb7d29c91aadd49';
      const storefrontEndpoint = `https://venusfashioninc.myshopify.com/api/2024-04/graphql.json`;
      //Query to grab Storefront cart gid
      const query = `
        query {
          cart(id: "gid://shopify/Cart/${cartToken}") {
            id
          }
        }
      `;
      try {
        const cartIdResponse = await fetch(storefrontEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontAccessToken
          },
          body: JSON.stringify({ query: query })
        });
        const cartIdData = await cartIdResponse.json();
        if (cartIdData.errors) {
          console.error(cartIdData.errors);
          alert(`${cartIdData.errors}`);
          return { success: false, errors: cartIdData.errors };
        }
        const cartId = cartIdData.data.cart.id;
        //Mutation to apply the discount code to the cart
        const applyDiscountCodeMutation = `
          mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
            cartDiscountCodesUpdate(
              cartId: $cartId
              discountCodes: $discountCodes
            ) {
              cart {
                id
                cost {
                  checkoutChargeAmount {
                    amount
                  }
                  totalAmount {
                    amount
                  }
                }
                checkoutUrl
                discountCodes {
                  code
                  applicable
                }
                discountAllocations{
                  discountedAmount {
                    amount
                  }
                }
              }
              userErrors {
                field
                message
              }
            }
          }
        `;
        // Applying discount code to the cart
        const applyDiscountResponse = await fetch(storefrontEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontAccessToken
          },
          body: JSON.stringify({
            query: applyDiscountCodeMutation,
            variables: {
              cartId: cartId,
              discountCodes: promoCode
            }
          })
        });
        const applyDiscountData = await applyDiscountResponse.json();
        const updatedCart = applyDiscountData.data;
        if (updatedCart.cartDiscountCodesUpdate.cart.discountCodes[0].applicable == false && updatedCart.cartDiscountCodesUpdate.cart.discountCodes[0].code !== '' ) {
          this.classList.add('discount-error');
          return
        } else {
          this.classList.remove('discount-error');
          document.querySelectorAll('[data-cart-section]').forEach((sectionWrapper) => {
            const sectionId = sectionWrapper.dataset.cartSection;
            const loader = document.querySelector(`template[data-loader="${sectionId}"]`)?.cloneNode(true);
            const sectionInnerHTML = sectionWrapper.innerHTML;
            sectionWrapper.innerHTML = `
              <intersection-loader 
                data-url="/cart"
                data-section-id="${sectionId}"
                class="${sectionWrapper.classList}"
              >${loader ? loader.innerHTML : sectionInnerHTML}</intersection-loader>
            `;
          });
          this.querySelector('#promoInput').value = ''
          return { success: true, cart: updatedCart };
        }
      } catch (error) {
        console.error('Error applying discount code:', error);
        alert(`Error applying discount code: ${error}`);
        return { success: false, error: error.message };
      }      
    }
    
    getCartId(promoCode) {
      fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        const cartId = data.token
        this.discountCode(cartId, promoCode)
          .then(() => {
           this.refreshCart();
           this.classList.remove('loading');
          })
      })
      .catch((error) => {
        console.error('Error:', error);
        alert(`Error: ${error}`);
        this.classList.remove('loading');
      });
    }
    
    refreshCart = async() => {
      const url = new URL(window.location.href, window.location.origin);
      const searchParams = new URLSearchParams(url.search);
      searchParams.set('section_id', this.sectionId);
      const urlToFetch = `${url.origin.toString()}${url.pathname.toString()}?${searchParams.toString()}`;
      await fetch(urlToFetch)
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = text;

          this.innerHTML = tempDiv.querySelector('mini-cart')?.innerHTML;
        });
    }
    
    open() {
      this.cartModalOpen = true;
      window.dispatchEvent(new CustomEvent('minicart:opened'));
      this.classList.remove('translate-x-full');
      document.querySelector('.section-header').classList.replace('z-10', 'z-[5]');
      if (!window.location.href.includes('/cart')) document.body.classList.add('overlay');
    }

    close() {
      this.cartModalOpen = false;
      this.classList.add('translate-x-full');
      document.querySelector('.section-header').classList.replace('z-[5]', 'z-10');
      document.body.classList.remove('overlay');
    }

    getRecommendedProducts() {
      if (!this.cart?.items.length) return;
      const recommendationsWrapper = this.querySelector('[data-recommended-product-row]');
      if (!recommendationsWrapper) return;

      const reccsToRenderPerCartItem = Math.round(5 / this.cart.items.length);
      recommendationsWrapper.innerHTML = ``;

      for (let i = 0; i < this.cart.items.length; i++) {
        const item = this.cart.items[i];
        fetch(`${Shopify.routes.root}recommendations/products.json?productId=${item.productId}`)
          .then(response => {
            return response.json()
          })
          .then(({ products }) => {
            const filteredReccs = products
              .filter(({ id, tags }) => {
                return !this.cart.items.find(({ productId }) => id == productId)
                && !tags.some(tag => tag === ('hide-product' || 'base-product'))
              })
              .slice(0, reccsToRenderPerCartItem)

              recommendationsWrapper.innerHTML += filteredReccs.map((recc) => {
                return `
                  <li>
                    <intersection-loader
                      data-url="${Shopify.routes.root}products/${recc.handle}"
                      data-section-id="quickbuy-widget"
                      class="bg-silverSand"
                      style="width: 284px; height: 194px;"
                    >
                      <div class="loader">
                        <span class="block w-12 h-12">
                          <svg class="animate-spin -ml-1 mr-3 h-full w-full text-accent1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                        </span>
                      </div>
                    </intersection-loader>
                  </li>
                `;
              }).join('');
          })
      }
    }

    async addToCart(input) {
      let body;
      let headers = {};
      let productId = null;
      let limit = null;
      let quantity = 1;
      let wishlistProduct = null;
    
      const isFormElement = input instanceof HTMLFormElement;
    
      if (isFormElement) {
        const formData = new FormData(input);
    
        productId = formData.get('product-id');
        limit = formData.get('limit');
    
        const ok = (limit && productId)
          ? await this.productQuantityValidation(productId, 1, 'add', limit)
          : true;
        if (!ok) return false;

        wishlistProduct = wishlist_items?.find(item => item.empi === Number(productId));
    
        formData.append('sections', this.sectionId);
        body = formData;
      } else if (input && typeof input === 'object') {
        const payload = input.data ?? input;
        productId = payload.id ?? null;
        limit = payload.limit ?? null;
        quantity = payload.quantity ?? 1;
    
        const ok = (limit && productId)
          ? await this.productQuantityValidation(productId, quantity, 'add', limit)
          : true;
        if (!ok) return false;
    
        payload.sections ??= this.sectionId;
        payload.sections_url ??= window.location.pathname;
    
        headers['Content-Type'] = 'application/json';
        body = JSON.stringify(payload);
      } else {
        console.error('addToCart: unsupported input');
        alert(`Error: unsupported input`);
        return false;
      }

      if (wishlistProduct) {
        const wishlist_icons = document.querySelectorAll(`[data-wishlist-product-id="${productId}"]`);
        const product = {
          epi: wishlistProduct.epi,
          empi: wishlistProduct.empi,
          du: wishlistProduct.du,
        }

        const removeSuccess = () => {
          swym_swat.fetchLists({
            callbackFn: getListSuccess,
            errorFn: swymOnError,
          });

          wishlist_icons.forEach(icon => {
            const svg = icon.querySelector('svg');

            svg.classList.remove('heart-icon-soft-red');
            svg.classList.add('heart-icon-white');
          });
        }

        const swymError = (error) => {
          console.error("Error while adding the Product to the List", error);
          alert(`Error while adding the Product to the List: ${error}`);
        }

        swym_swat.deleteFromList(default_list_id, product, removeSuccess, swymError);
      }
    
      try {
        const addResp = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers,
          body
        });
        const addJson = await addResp.json();
    
        this.updateCartHtml(addJson);
        this.getRecommendedProducts();
    
        const cartResp = await fetch(`${window.Shopify.routes.root}cart.js`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
        const cartData = await cartResp.json();
    
        const {
          sku,
          quantity: addedQty,
          untranslated_product_title,
          price,
          product_title
        } = addJson;
    
        const [styleNumber, , colorCode] = sku.split('-');
        const splitTitle = product_title.split(' - ');
    
        if (isFormElement) {
          input.closest('product-form')?.dispatchEvent(new Event('cart:cartAddItem'));
        }
        window.dispatchEvent(new CustomEvent('cart:cartAddItem', {
          detail: {
            bagId: cartData.token,
            bagAddQuantity: addedQty,
            productTitle: untranslated_product_title,
            styleNumber,
            itemCode: `${styleNumber}-${colorCode}`,
            skuCode: sku,
            bagAddPrice: price / 100,
            bagAddColorCode: colorCode,
            bagAddColorName: splitTitle[splitTitle.length - 1]
          }
        }));
    
        return addJson;
      } catch (err) {
        console.error(err);
        alert(`Error: ${err}`);
        return false;
      }
    }
    
    async updateCartHtml(res) {
      let newHtml = res?.sections?.[`${this.sectionId}`];
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newHtml;
      this.innerHTML = tempDiv.querySelector('mini-cart')?.innerHTML;
      const count = Number(tempDiv.querySelector('mini-cart')?.dataset.cartItemCount || '');
      this.cart = JSON.parse(tempDiv.querySelector('mini-cart')?.dataset.cartJson || null);
      if (!this.cart) {
        // Could not fetch new html, redirect to cart as a fallback
        window.location.href = '/cart';
      }
      
      if (!count) return;
      [...document.querySelectorAll('[data-cart-count]')].forEach(cartCount => {
        cartCount.innerHTML = count > 0 ? count : '';

        cartCount.classList.toggle('hidden', count === 0);
      });
    }
    
    async updateQty(id, qty) {
      const updates = {};
      updates[id] = qty;
      const data = {
        updates,
        sections: [`${this.sectionId}`],
      };
            
      const cartContents = fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error:', error);
          alert(`Error: ${error}`);
        });
      return cartContents;
    };
    
    async productQuantityValidation(id, qty, method, limit) {
      const atcErrors = document.querySelector(`[data-add-to-cart-errors]`)
      let quantity = qty;
      let quantityToAdd = qty;
      atcErrors.classList.add(`hidden`);
      
      const products_in_cart = await fetch(`${Shopify.routes.root}cart.js`)
        .then(res => res.json())
        .then((cart) => cart.items.filter(item => item.product_id == Number(id)));
        
      if (products_in_cart.length) {
        const total_quantity = products_in_cart.reduce((count, product) => count + product.quantity, 0);
        
        if (method === `update`) {
          quantityToAdd = qty - total_quantity;
        } else {
          quantity += total_quantity;
        }
      }
      
      if (quantity > Number(limit)) {
        atcErrors.classList.remove(`hidden`);
        atcErrors.innerHTML = `Your cart can only contain 1 gift card at a time.`;
        return false;
      }
      
      return true;
    }
    switchTab(tab) {
      const tabElement = this.querySelector(`[data-tab-target=${tab}]`);
      [...this.querySelectorAll('[data-tab-container]')].forEach((el) => {
        if (el.dataset.tabContainer === tab) {
          el.style.display = null;
          return;
        }
        el.style.display = 'none';
      });
      [...this.querySelectorAll('[data-tab-target]')].forEach((el) => {
        el.classList.remove('active');
        el.setAttribute('aria-current', false);
        el.setAttribute('tabindex', '-1');
      });
      tabElement.classList.add('active');
      tabElement.setAttribute('aria-current', true);
      tabElement.setAttribute('tabindex', '0');
    }
  }

  customElements.define('mini-cart', MiniCart);
}